import React from 'react'

function validimg() {
  return (
    
    <div>validimg</div>
  )
}

export default validimg